import { combineReducers } from 'redux';

import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import levelDetailsReducer from './reducers/levelDetailsReducer';
import levelIndexReducer from './reducers/levelIndexReducer';
import storyReducer from './reducers/storyReducer';
import reportingDetails from './reducers/reportingDetailsReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  levelDetails: levelDetailsReducer,
  story: storyReducer,
  levelIndex: levelIndexReducer,
  reportingDetails,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
